<!--
2023-05-24 Matt 常态化流水返利活动规则，读取静态文件内容
-->
<template>
  <div class="RulePage">
    <TopBack :title="$t('lang.betActivityRegularly.rules')" />

    <img
      class="introduceImg"
      alt="agent-rules"
      src="https://betapp-images.s3.ap-northeast-1.amazonaws.com/Homebanner/l7jajbpuq7maond6xka765aqm9ub5x21Cashback_PGE.png"
    >

    <div class="rules" v-html="ruleHtml">
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import TopBack from '@/components/TopBack/index'

export default {
  name: 'BetActivityRegularlyRule',
  components: {
    TopBack
  },
  data () {
    return {
      ruleHtml: ''
    }
  },
  watch: {
    '$store.state.locale': function () {
      this.loadData()
    }
  },
  mounted () {
    this.loadData()
  },
  methods: {
    loadData: function () {
      let formulaHtml = ''
      /* await request('post', 'innovation/cashback/getsetting', {}).then(res => {
        if (res !== null) {
          res.forEach(element => {
            formulaHtml += '<tr style="border-bottom: #686868 solid 1px">' +
              '               <td style="text-align: center; color: #F6D9AA; width: 22.22%;" coolspan="2">' + element.BetAmount + '</td>' +
              '               <td style="text-align: center; color: #F6D9AA; width: 11.11%;" coolspan="1">' + element.Card.toFixed(1) + '%</td>    ' +
              '               <td style="text-align: center; color: #F6D9AA; width: 11.11%;" coolspan="1">' + element.CrashGames.toFixed(1) + '%</td>' +
              '               <td style="text-align: center; color: #F6D9AA; width: 11.11%;" coolspan="1">' + element.SlotGames.toFixed(1) + '%</td>    ' +
              '               <td style="text-align: center; color: #F6D9AA; width: 11.11%;" coolspan="1">' + element.FishingGames.toFixed(1) + '%</td>' +
              '               <td style="text-align: center; color: #F6D9AA; width: 11.11%;" coolspan="1">' + element.LiveCasino.toFixed(1) + '%</td>    ' +
              '               <td style="text-align: center; color: #F6D9AA; width: 11.11%;" coolspan="1">' + element.SportsGames.toFixed(1) + '%</td>    ' +
              '               <td style="text-align: center; color: #F6D9AA; width: 11.11%;" coolspan="1">' + element.Lottery.toFixed(1) + '%</td>    ' +
              '             </tr>'
          })
        }
      }) */
      let languagePre = this.$store.state.locale
      languagePre = languagePre === 'EN' ? '' : '-' + languagePre
      const htmlFileURL = location.origin + '/static/promotionRules/CashBack-' + this.$store.state.internation + languagePre + '.html'
      axios.get(htmlFileURL).then(res => {
        if (res.data != null) {
          let htmlDate = ''
          htmlDate = res.data
          this.ruleHtml = htmlDate.replace('Reward-details', formulaHtml)
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
  .RulePage {
    padding:56px 0 70px 0;
    background-color: rgba(0,0,0,.9);
    height: 92vh;
    overflow-y: hidden;
    text-align: center;

    .introduceImg {
      width: 90vw;
      margin: 20px auto 0;
      border-radius: 5px;
    }

    .rules {
      height: 70vh;
      width: 98vw;
      margin: 5px auto 20px;
      padding-bottom: 220px;
      overflow-y: scroll;

    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/CashBack/rules.vue